/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions */
import { FC } from 'react';
import { RangeInput, useRefinementList } from 'react-instantsearch-hooks-web';
import { BaseFilter } from './BaseFilter';
import { RangeSlider } from './RangeSlider';
import { useEtimTranslation } from '../../../use/etim-translation';
import MultiselectOption from './MultiselectOption';
import { useSortedItems, hasStrings } from '../hooks/useSortedItems';

type MultipleSelectFilterProps = {
  title: string;
  // eslint-disable-next-line react/require-default-props
  tooltip?: string;
  attribute: string;
  opened: boolean;
  // eslint-disable-next-line react/require-default-props
  unit?: string;
};

declare global {
  interface Window {
    collectionRangeSlider: boolean;
    collectionRangeSliderMax: number;
  }
}

export const MultipleSelectFilter: FC<MultipleSelectFilterProps> = ({ title, unit, tooltip, attribute, opened }) => {
  const { canRefine, items, refine } = useRefinementList({ attribute, limit: 1000 });
  const { translateEtimValue } = useEtimTranslation(attribute);

  const sortedItems = useSortedItems(items, attribute);

  if (!canRefine || items.length === 1) {
    return null;
  }

  return (
    <BaseFilter title={title} unit={unit} tooltip={tooltip} opened={opened}>
      {window.collectionRangeSlider && items.length > window.collectionRangeSliderMax && !hasStrings(items) ? (
        <div className="range-slider-widget">
          <RangeInput attribute={attribute} classNames={{ submit: 'button button--primary' }} />
          <RangeSlider attribute={attribute} />
        </div>
      ) : (
        sortedItems.map((item) => (
          <MultiselectOption
            key={item.value}
            item={item}
            refine={refine}
            translateEtimValue={translateEtimValue}
            attribute={attribute}
          />
        ))
      )}
    </BaseFilter>
  );
};
